<template>
  <div class="proce-payment-record">
    <GlobalInfoBar title="异常付款单据重置记录" content="留存订单重置记录" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <Form />
      </div>
      <Table />
    </GlobalChunk>
  </div>
</template>

<script>
import Form from "./Form";
import Table from "./Table";

export default {
  name: "proce-payment-record",
  components: {
    Form,
    Table,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.proce-payment-record {
}
</style>
